import React, { useState, useEffect } from 'react'
import { useParams, Link } from 'react-router-dom'
import './Standings.css'
import StatsAndStandingsHome from '../../shared/components/Navigation/StatsAndStandingsHome'
import StatsAndStandingsHomeNavigation from '../../shared/components/Navigation/StatsAndStandingsHomeNavigation'
//import { useHttpClient } from '../../shared/hooks/http-hook'
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner'
import ErrorModal from '../../shared/components/UIElements/ErrorModal'
import SearchByLeagueForStandings from '../../shared/components/UIElements/SearchByLeagueForStandings'
import Banner from '../../shared/components/Navigation/Banner'
import sLogo from '../../images/s_logo_png.png'

const Standings = () => {
	console.log('inside Standings')
	//const { sendRequest, clearError } = useHttpClient()
	const [error, setError] = useState()
	const [isLoading, setIsLoading] = useState(false)
	const [loadedStandings, setLoadedStandings] = useState()
	const [numberOfTeamsTotal, setNumberOfTeamsTotal] = useState()
	const [loadedStandingsArray, setLoadedStandingsArray] = useState([])
	const [leagueName, setLeagueName] = useState()
	const [divisionName, setDivisionName] = useState()
	const [session, setSession] = useState()
	const [year, setYear] = useState()
	const [masterArray, setMasterArray] = useState()
	const [combineEastWest, setCombineEastWest] = useState(false)
	//const [returnArray, setReturnArray] = useState([])

	const [isMobile, setIsMobile] = useState(window.innerWidth <= 440)

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth <= 440)
		}

		window.addEventListener('resize', handleResize)
		return () => window.removeEventListener('resize', handleResize)
	}, [])

	const leagueId = useParams().leagueId

	leagueId &&
		console.log('- - - - - - - inside Standings with a leagueId: ' + leagueId)
	!leagueId &&
		console.log(
			'- - - - - - - - inside Standings WITHOUT A LEAGUE ID - - - - - - ',
		)

	//call to getStandings in the league-controller
	useEffect(() => {
		console.log('we are inside the first useEffect')
		if (!leagueId) return
		const sendRequest = async () => {
			setIsLoading(true)
			try {
				const response = await fetch(
					`${process.env.REACT_APP_BACKEND_URL}/league/leagues/${leagueId}/standings`,
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				if (responseData.listOfTeams[0].divisionName) {
					setDivisionName(responseData.listOfTeams[0].divisionName)
				} else {
					setDivisionName('')
				}

				setMasterArray(responseData.masterMasterArray)
				setLoadedStandings(responseData.listOfTeams)
				setNumberOfTeamsTotal(responseData.numberOfTeamsTotal)
				setLoadedStandingsArray(responseData.listOfTeamsArray)
				setLeagueName(responseData.leagueName)
				setSession(responseData.session)
				setYear(responseData.year)
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			setIsLoading(false)
		}
		sendRequest()
	}, [leagueId])

	let numberOfTeams

	numberOfTeams = numberOfTeamsTotal && numberOfTeamsTotal.length
	console.log('numberOfTeamsTotal: ' + numberOfTeams)

	//So, when masterArray comes to us from the backend, it can be a pretty long list
	//if there were many sets of two teams tied for points.  For example, if there were
	//four sets of two teams tied in points, this masterarray would be four times the
	//size we need.  However, the last of those four would be the correct version.
	//So, we reverse the long incoming array, then cut it (splice it) at however many
	//number of teams there are, then we reverse it again.
	masterArray && masterArray.reverse()
	masterArray && masterArray.splice(numberOfTeamsTotal)
	masterArray && masterArray.reverse()

	let groupedArray
	groupedArray = []
	if (masterArray) {
		const uniqueDivisionsArray = masterArray.map((item) => item.divisionName)

		const toFindUniques = (arry) =>
			arry.filter((item, index) => arry.indexOf(item) === index)

		const uniques = toFindUniques(uniqueDivisionsArray)

		console.log(
			'there are ' + uniques.length + ' divisions.  They are ' + uniques,
		)

		if (uniques.length > 1) {
			console.log(
				'we have more than one division, lets split them up into separate arrays',
			)
			for (const element of uniques) {
				const item = masterArray.filter((el) => el.divisionName === element)
				groupedArray.push(item)
			}
		}
	}
	//
	//
	const errorHandler = () => {
		setError(null)
	}
	//
	//
	const getStandingsGridClass = (divisionName = '') => {
		if (divisionName === "Men's A East") return 'mens-a-east'
		if (divisionName === "Men's A West") return 'mens-a-west'
		if (divisionName === "Men's B East") return 'mens-b-east'
		if (divisionName === "Men's B West") return 'mens-b-west'
		return ''
	}
	//
	//
	const getParentDivisionName = (divisionName = '') => {
		if (divisionName.includes("Men's A")) return "Men's A"
		if (divisionName.includes("Men's B")) return "Men's B"
		return divisionName.replace(/\s+(East|West)$/i, '')
	}

	const getGamesPlayed = (team) => {
		return (
			team.wins +
			team.losses +
			team.ties +
			team.shootoutLosses +
			team.overtimeLosses
		)
	}

	const getWinningPercentage = (team) => {
		const gamesPlayed = getGamesPlayed(team)

		if (!gamesPlayed) return 0

		return (team.wins + team.ties * 0.5) / gamesPlayed
	}

	const sortStandings = (a, b) => {
		return (
			b.points - a.points ||
			getWinningPercentage(b) - getWinningPercentage(a) ||
			b.wins - a.wins ||
			b.goalsFor - b.goalsAgainst - (a.goalsFor - a.goalsAgainst) ||
			b.goalsFor - a.goalsFor ||
			a.teamName.localeCompare(b.teamName)
		)
	}

	const combineEastWestStandings = (groups = []) => {
		const combined = {}

		groups.forEach((group) => {
			const parentDivision = getParentDivisionName(group[0].divisionName)

			if (!combined[parentDivision]) {
				combined[parentDivision] = []
			}

			combined[parentDivision].push(...group)
		})

		return Object.keys(combined).map((divisionName) => {
			return combined[divisionName].slice().sort(sortStandings)
		})
	}
	//
	//
	if (groupedArray && groupedArray.length < 1) {
		console.log('groupedArray is less than 1, so lets retun this')
		return (
			<div style={{ overflowX: 'hidden' }}>
				<React.Fragment>
					<StatsAndStandingsHome />
					<StatsAndStandingsHomeNavigation leagueId={leagueId} />
					{/* {!isMobile && (
				<div style={{ marginTop: '5rem' }}>
					<Banner />
				</div>
			)} */}
					{!isMobile && <Banner />}
					<ErrorModal error={error} onClear={errorHandler} />
					{isLoading && (
						<div className='center'>
							<LoadingSpinner />
						</div>
					)}
					{!isLoading && masterArray && (
						<div className='Roster'>
							<h1>Tournament Standings</h1>
							<h1>
								{leagueName}{' '}
								{divisionName && ' - ' + divisionName + ' Division'}
							</h1>
							<h2>
								{session} {year}
							</h2>
							<p style={{ textAlign: 'center' }}>
								(Click on a team to go to their roster and schedule page)
							</p>

							<div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
								<label style={{ fontWeight: '600', cursor: 'pointer' }}>
									<input
										type='checkbox'
										checked={combineEastWest}
										onChange={() => setCombineEastWest((prev) => !prev)}
										style={{ marginRight: '0.5rem' }}
									/>
									Combine East / West Standings
								</label>
							</div>

							<table id='roster' cellSpacing={'0'} cellPadding={'0'}>
								<thead>
									<tr>
										<th>Team</th>
										<th>GP</th>
										<th>W</th>
										<th>L</th>
										<th>T</th>
										{/* <th>OTL</th>
								<th>SOL</th> */}
										<th>GF</th>
										<th>GA</th>
										<th>GD</th>
										<th>Pts.</th>
										<th>%</th>
									</tr>
								</thead>
								<tbody>
									{masterArray.map((team, key) => {
										return (
											<tr key={key}>
												<td className='tableDataTeamName'>
													<Link
														style={{
															textDecoration: 'none',
															color: 'black',
															fontWeight: 600,
														}}
														to={`${team.divisionName}/${year}/${team.teamName}`}
													>
														{team.teamName}
													</Link>
												</td>
												<td>
													{team.wins +
														team.losses +
														team.ties +
														team.shootoutLosses +
														team.overtimeLosses}
												</td>
												<td>{team.wins}</td>
												<td>{team.losses}</td>
												<td>{team.ties}</td>
												{/* <td>{team.overtimeLosses}</td>
										<td>{team.shootoutLosses}</td> */}
												<td>{team.goalsFor}</td>
												<td>{team.goalsAgainst}</td>
												<td>{team.goalsFor - team.goalsAgainst}</td>
												<td>{team.points}</td>
												<td>
													{!isNaN(
														Number(
															(team.wins + team.ties * 0.5) /
																(team.wins +
																	team.losses +
																	team.overtimeLosses +
																	team.shootoutLosses +
																	team.ties),
														).toFixed(3),
													) &&
														Number(
															(team.wins + team.ties * 0.5) /
																(team.wins +
																	team.losses +
																	team.overtimeLosses +
																	team.shootoutLosses +
																	team.ties),
														).toFixed(3)}
												</td>
											</tr>
										)
									})}
								</tbody>
							</table>
						</div>
					)}
					{!isLoading && !masterArray && <SearchByLeagueForStandings />}
				</React.Fragment>
			</div>
		)
	} else if (groupedArray && groupedArray.length > 0) {
		console.log('groupedArray is greater than 0, so lets return this shit')

		const displayGroupedArray = combineEastWest
			? combineEastWestStandings(groupedArray)
			: groupedArray

		return (
			<div style={{ overflowX: 'hidden' }}>
				<React.Fragment>
					<StatsAndStandingsHome />
					<StatsAndStandingsHomeNavigation leagueId={leagueId} />
					<ErrorModal error={error} onClear={errorHandler} />
					{isLoading && (
						<div className='center'>
							<LoadingSpinner />
						</div>
					)}
					{/* {!isMobile && (
				<div style={{ marginTop: '5rem' }}>
					<Banner />
				</div>
			)} */}
					{!isMobile &&
						(window.innerWidth < 1200 || window.innerWidth > 1400) && (
							<Banner />
						)}
					{/* <SearchByLeagueForStandings /> */}
					{!isMobile &&
						(window.innerWidth < 1200 || window.innerWidth > 1400) && (
							<h1 style={{ marginTop: '2rem' }}>{leagueName}</h1>
						)}
					<div className='mobileStandingsHero'>
						{/* <div className='mobileStandingsHero__icon'>🏆</div> */}
						<div className='standingsHeroTop'>
							<div className='standingsHeroLine'></div>

							<div className='standingsHeroLogoCircle'>
								<img src={sLogo} alt='Shirey logo' />
							</div>

							<div className='standingsHeroLine'></div>
						</div>
						<h1>Standings</h1>
						<div className='mobileStandingsLeaguePill'>
							{year} {leagueName}
						</div>
						<p>Click on a team name to view their roster</p>
					</div>

					<h2 className='desktopStandingsTitle'>{year} Standings</h2>

					<div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
						<label style={{ fontWeight: '600', cursor: 'pointer' }}>
							<input
								type='checkbox'
								checked={combineEastWest}
								onChange={() => setCombineEastWest((prev) => !prev)}
								style={{ marginRight: '0.5rem' }}
							/>
							Combine East / West Standings
						</label>
					</div>

					{/* <h1>More than one group here. {groupedArray.length}</h1> */}
					<div className='standingsGridLarge'>
						{displayGroupedArray.map((group, key) => {
							return (
								<div
									className={`Roster standingsCard ${
										combineEastWest
											? ''
											: getStandingsGridClass(group[0].divisionName)
									}`}
									key={key}
								>
									<h4 className='standingsDivisionHeading'>
										<span></span>
										{combineEastWest
											? `${getParentDivisionName(group[0].divisionName)} Division`
											: `${group[0].divisionName} Division`}
										<span></span>
									</h4>

									<table id='roster' cellSpacing={'0'} cellPadding={'0'}>
										<thead>
											<tr>
												<th>Team</th>
												<th>GP</th>
												<th>W</th>
												<th>L</th>
												<th>T</th>
												{/* <th>OTL</th>
										<th>SOL</th> */}
												<th>GF</th>
												<th>GA</th>
												<th>GD</th>
												<th>Pts.</th>
												<th>%</th>
											</tr>
										</thead>
										<tbody>
											{group.map((team, key) => {
												return (
													<tr key={key}>
														<td className='tableDataTeamName'>
															<Link
																style={{
																	textDecoration: 'none',
																	color: 'black',
																	fontWeight: 600,
																}}
																to={`${team.divisionName}/${year}/${team.teamName}`}
															>
																{team.teamName}
															</Link>
														</td>
														<td>
															{team.wins +
																team.losses +
																team.ties +
																team.shootoutLosses +
																team.overtimeLosses}
														</td>
														<td>{team.wins}</td>
														<td>{team.losses}</td>
														<td>{team.ties}</td>
														{/* <td>{team.overtimeLosses}</td>
												<td>{team.shootoutLosses}</td> */}
														<td>{team.goalsFor}</td>
														<td>{team.goalsAgainst}</td>
														<td>{team.goalsFor - team.goalsAgainst}</td>
														<td>{team.points}</td>
														<td>
															{!isNaN(
																Number(
																	(team.wins + team.ties * 0.5) /
																		(team.wins +
																			team.losses +
																			team.overtimeLosses +
																			team.shootoutLosses +
																			team.ties),
																).toFixed(3),
															) &&
																Number(
																	(team.wins + team.ties * 0.5) /
																		(team.wins +
																			team.losses +
																			team.overtimeLosses +
																			team.shootoutLosses +
																			team.ties),
																).toFixed(3)}
														</td>
													</tr>
												)
											})}
										</tbody>
									</table>
								</div>
							)
						})}
					</div>
				</React.Fragment>
			</div>
		)
	} else if (!groupedArray) {
		return (
			<div style={{ overflowX: 'hidden' }}>
				<React.Fragment>
					<div>
						{(() => {
							console.log('YOU ARE HERE ONE.  There is NO groupedArray')
							return null // or nothing
						})()}
					</div>
					<StatsAndStandingsHome />
					<h1 style={{ marginTop: '7rem' }}>
						Go to Schedules tab and pick a league
					</h1>
				</React.Fragment>
			</div>
		)
	}
}

export default Standings
